const options = [
  {
    key: '',
    label: 'sidebar.dashboard',
    leftIcon: 'dashboard',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops', 'Tester']
  },
  {
    key: 'applications',
    label: 'sidebar.applications',
    leftIcon: 'container',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester',
      'Alternate Channel'
    ],
    children: [
      {
        key: 'applications-digi',
        label: 'sidebar.digi',
        leftIcon: 'container',
        roles: ['Alternate Channel']
      },
      {
        key: 'applications-celcom',
        label: 'sidebar.celcom',
        leftIcon: 'container',
        roles: ['Alternate Channel']
      }
    ]
  },
  {
    key: 'change-plan-request',
    label: 'sidebar.changePlanRequest',    
    leftIcon: 'sync',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    key: 'troubleshooting',
    label: 'sidebar.troubleshooting',
    leftIcon: 'tool',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin','Customer Service']
  },  
  {
    key: 'lead-assignment',
    label: 'sidebar.lead-assignment',
    leftIcon: 'team',
    roles: ['FBB Operations Lead'],
    children: [
      {
        key: 'assign-tasks',
        label: 'sidebar.assign-tasks',
        leftIcon: 'container',
        roles: ['FBB Operations Lead']
      },
      {
        key: 'unassigned-tasks',
        label: 'sidebar.unassigned-tasks',
        leftIcon: 'container',
        roles: ['FBB Operations Lead']
      }
    ]
  },
  {
    key: 'radius-profiles',
    label: 'sidebar.radiusProfiles',
    leftIcon: 'user',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Corporate Admin', 'Admin', 'Customer Service', 'Tester']
  },
  {
    key: 'access-partner',
    label: 'sidebar.accessPartner',
    leftIcon: 'search',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Customer Service', 'Tester']
  },
  {
    key: 'users',
    label: 'sidebar.users',
    leftIcon: 'idcard',
    roles: ['Admin', 'User Admin', 'Partner Support Admin']
  },
  {
    key: 'settings',
    label: 'sidebar.operations',
    leftIcon: 'desktop',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops', 'Tester'],
    children: [
      {
        key: 'daisy-failure-tracker',
        label: 'sidebar.daisyFailureTracking',
        leftIcon: 'warning',
        roles: ['Admin']
      },
      {
        key: 'promotions-config',
        label: 'sidebar.promotions',
        leftIcon: 'gift',
        roles: ['Admin']
      },
      {
        key: 'sidebar-role-config',
        label: 'sidebar.sidebarRoleConfig',
        leftIcon: 'setting',
        roles: [
         'Admin',
         'Tester'
        ]
      },
      {
        key: 'task-assign-upload',
        label: 'sidebar.uploadTask',
        leftIcon: 'container',
        roles: ['FBB Operations Lead']
      },
      {
        key: 'wfm-file-upload',
        label: 'sidebar.wfmUpload',
        leftIcon: 'container',
        roles: ['FBB Operations Lead']
      },
      {
        key: 'data-extraction',
        label: 'sidebar.data_extraction',
        leftIcon: 'file-search',
        roles: ['Tester']
      },
      {
        key: 'radius-profiles/update-domain',
        label: 'sidebar.updateRadiusDomain',
        leftIcon: 'upload',
        roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops', 'Tester']
      }
    ]
  }
];

const routes = [
  {
    path: ''
  },
  {
    path: 'radius-profiles',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Corporate Admin', 'Admin', 'Customer Service', 'Tester']
  },
  {
    path: 'radius-profiles/:id/edit',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Corporate Admin', 'Admin', 'Customer Service', 'Tester']
  },
  {
    path: 'access-partner',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Customer Service', 'Tester']
  },
  {
    path: 'access-partner/:id/info',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Customer Service', 'Tester']
  },
  {
    path: 'users',
    roles: ['Admin', 'User Admin', 'Partner Support Admin']
  },
  {
    path: 'users/create',
    roles: ['Admin', 'User Admin', 'Partner Support Admin']
  },
  {
    path: 'users/:userId/edit',
    roles: ['Admin', 'User Admin', 'Partner Support Admin']
  },
  {
    path: 'plans',
    roles: ['Admin']
  },
  {
    path: 'plans/create',
    roles: ['Admin']
  },
  {
    path: 'plans/:planId/edit',
    roles: ['Admin']
  },
  {
    path: 'plans/:planId/replicate',
    roles: ['Admin']
  },
  {
    path: 'groups',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Tester']
  },
  {
    path: 'applications',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester'
    ]
  },
  {
    path: 'applications-digi',
    roles: ['Alternate Channel']
  },
  {
    path: 'applications-celcom',
    roles: ['Alternate Channel']
  },
  {
    path: 'daisy-failure-tracker',
    roles: ['Admin']
  },
  {
    path: 'applications/files',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Tester'
    ]
  },
  {
    path: 'applications/create',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'celcom/create',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'applications/:session/edit',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'celcom/:session/edit',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'celcomdigi/create',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'celcomdigi/:session/edit',
    roles: [
      'FBB Operations',
      'FBB Operations Lead',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester',
      'Alternate Channel'
    ]
  },
  {
    path: 'broadbands/files',
    roles: ['Admin', 'Tester']
  },
  {
    path: 'change-plan-request',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    path: 'change-plan-request/celcom/add',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    path: 'change-plan-request/celcom/:session/edit',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    path: 'change-plan-request/digi/add',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    path: 'change-plan-request/digi/:session/edit',
    roles: [
      'Admin',
      'FBB Operations',
      'FBB Operations Lead',
      'DIGI Store Manager',
      'DIGI Store Staff',
      'DIGI Dealer',
      'Telesales Manager',
      'Telesales Staff',
      'Customer Service',
      'Alternate Channel'
    ]
  },
  {
    path: 'troubleshooting',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Customer Service']
  },
  {
    path: 'troubleshooting/details',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Customer Service']
  },
  {
    path: 'notifications',
    roles: [
      'DIGI Dealer',
      'DIGI Store Staff',
      'DIGI Store Manager',
      'Telesales Staff',
      'Telesales Manager',
      'Alternate Channel'
    ]
  },
  {
    path: 'leads',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Tester']
  },
  {
    path: 'leads/:session/edit',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Tester']
  },
  {
    path: 'leads/:session/convert',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Tester']
  },
  {
    path: 'assign-tasks',
    roles: ['FBB Operations Lead']
  },
  {
    path: 'unassigned-tasks',
    roles: ['FBB Operations Lead']
  },
  {
    path: 'task-assign-upload',
    roles: ['FBB Operations Lead']
  },
  {
    path: 'assignment-config',
    roles: ['FBB Operations Lead']
  },
  {
    path: 'tdc-csv',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin']
  },
  {
    path: 'simserialnumbers',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin']
  },
  {
    path: 'simserialnumbers/create',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin']
  },
  {
    path: 'appointment-config',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops']
  },
  {
    path: 'wfm-file-upload',
    roles: ['FBB Operations Lead']
  },
  {
    path: 'installers',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops']
  },
  {
    path: 'installers/create',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops']
  },
  {
    path: 'installers/:installerId/edit',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops']
  },
  {
    path: 'installers/regions',
    roles: ['FBB Operations', 'FBB Operations Lead', 'Admin', 'Marketing Ops']
  },
  {
    path: 'corporateApplications',
    roles: [
      'Admin',
      'Corporate Admin',
      'Corporate Dealer',
      'Marketing Ops',
      'FBB Operations',
      'FBB Operations Lead',
      'Tester'
    ]
  },
  {
    path: 'corporateApplications/create',
    roles: [
      'Admin',
      'Corporate Admin',
      'Corporate Dealer',
      'Marketing Ops',
      'FBB Operations',
      'FBB Operations Lead',
      'Tester'
    ]
  },
  {
    path: 'corporateApplications/:session/edit',
    roles: [
      'Admin',
      'Corporate Admin',
      'Corporate Dealer',
      'Marketing Ops',
      'FBB Operations',
      'FBB Operations Lead',
      'Tester'
    ]
  },
  {
    path: 'internet-protocol',
    roles: ['Corporate Admin', 'Admin']
  },
  {
    path: 'address-upload',
    roles: ['Wholesales', 'Admin', 'FBB Operations', 'FBB Operations Lead', 'Tester']
  },
  {
    path: 'saf-upload',
    roles: ['Admin', 'Marketing Ops']
  },
  {
    path: 'serial-upload',
    roles: ['Admin', 'Marketing Ops']
  },
  {
    path: 'reports/:reportId'
  },
  {
    path: 'promotions-config',
    roles: ['Admin']
  },
  {
    path: 'promotions-config/create',
    roles: ['Admin']
  },
  {
    path: 'promotions-config/:promotionId/edit',
    roles: ['Admin']
  },
  {
    path: 'data-extraction',
    roles: ['Tester']
  },
  {
    path: '*'
  }
];

const defaultSidebar = {
  sidebar_menu: options,
  sidebar_router: routes
}

export default defaultSidebar;
